import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { AlertCircle, Sun, Wind, Sparkles, Droplet, Frown } from 'lucide-react';

const SkinProblems = () => {
  const problems = [
    {
      icon: <Sparkles size={28} />,
      title: 'Premature Ageing',
      description: 'Appearance of wrinkles or fine lines'
    },
    {
      icon: <AlertCircle size={28} />,
      title: 'Collagen Production',
      description: 'A major health and beauty concern in India primarily due to environmental factors (high UV exposure), aging, and accelerated breakdown from high pollution levels and lifestyle choices'
    },
    {
      icon: <Sun size={28} />,
      title: 'Slow Skin Cell Regeneration',
      description: 'Due to intense UV Radiation, High Levels of pollution and lifestyle'
    },
    {
      icon: <Wind size={28} />,
      title: 'Skin Pigmentation',
      description: 'Dark spots, acne breakouts'
    },
    {
      icon: <Droplet size={28} />,
      title: 'Skin Dryness & Dullness',
      description: 'Loss of natural moisture and radiance'
    }
  ];

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'hsl(30, 30%, 98%)' }}>
      <Navigation />

      {/* Hero Section */}
      <section className="relative py-12 sm:py-16 lg:py-20">
        <div className="absolute inset-0 overflow-hidden">
          <img
            src="https://storage.googleapis.com/fenado-ai-farm-public/generated/e29f496a-ea08-4288-b927-470c8218be5b.webp"
            alt="Background"
            className="w-full h-full object-cover opacity-30"
          />
        </div>
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6" style={{ fontFamily: 'Quicksand, sans-serif', color: 'hsl(345, 60%, 60%)', lineHeight: 1.4 }}>
            Indian Skin Problems
          </h1>
        </div>
      </section>

      {/* Problem Statement */}
      <section className="py-8 sm:py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-sm p-6 sm:p-8 lg:p-12 mb-8 sm:mb-12">
            <p className="text-base sm:text-lg leading-relaxed mb-4" style={{ fontFamily: 'Nunito, sans-serif', color: 'hsl(30, 20%, 20%)', lineHeight: 1.7 }}>
              Since 40 years, ladies are using more or less one single cream for their daily glow, without realizing their effects or even if it's benefitting or not?
            </p>
            <p className="text-base sm:text-lg leading-relaxed" style={{ fontFamily: 'Nunito, sans-serif', color: 'hsl(30, 20%, 20%)', lineHeight: 1.7 }}>
              Indian skin problems are now on an increase because of harmful sun rays, pollution, and harmful chemicals.
            </p>
          </div>

          {/* Common Skin Problems */}
          <div>
            <h2 className="text-2xl sm:text-3xl font-bold mb-8 text-center" style={{ fontFamily: 'Quicksand, sans-serif', color: 'hsl(345, 60%, 60%)' }}>
              Common Skin Problems
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
              {problems.map((problem, index) => (
                <div key={index} className="bg-white rounded-2xl shadow-sm p-6 sm:p-8 hover:shadow-md transition-shadow duration-300">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 p-3 rounded-lg" style={{ backgroundColor: 'hsl(345, 60%, 96%)' }}>
                      <div style={{ color: 'hsl(345, 60%, 60%)' }}>
                        {problem.icon}
                      </div>
                    </div>
                    <div>
                      <h3 className="text-lg sm:text-xl font-bold mb-2" style={{ fontFamily: 'Quicksand, sans-serif', color: 'hsl(30, 20%, 20%)' }}>
                        {problem.title}
                      </h3>
                      <p className="text-sm sm:text-base leading-relaxed" style={{ fontFamily: 'Nunito, sans-serif', color: 'hsl(30, 10%, 50%)', lineHeight: 1.7 }}>
                        {problem.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Call to Action */}
          <div className="mt-12 bg-white rounded-2xl shadow-sm p-6 sm:p-8 lg:p-12 text-center" style={{ background: 'linear-gradient(135deg, hsl(345, 60%, 96%) 0%, hsl(345, 60%, 96%) 100%)' }}>
            <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold mb-4" style={{ fontFamily: 'Quicksand, sans-serif', color: 'hsl(345, 60%, 60%)' }}>
              Moonlit is here to change that
            </h3>
            <p className="text-base sm:text-lg leading-relaxed mb-6" style={{ fontFamily: 'Nunito, sans-serif', color: 'hsl(30, 20%, 20%)', lineHeight: 1.7 }}>
              A Daily Beauty Cream that not only gives you glow but benefits your skin with quality ingredients
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SkinProblems;
